/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Overview1Inputs */

const id_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikhtisar`)
};

const ms_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambaran Keseluruhan`)
};

const da_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversigt`)
};

const de_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

const en_us2_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const es_es2_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

const es_mx2_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

const fil_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkalahatang-ideya`)
};

const fr_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu`)
};

const it_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica`)
};

const hu_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áttekintés`)
};

const nl_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overzicht`)
};

const no_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversikt`)
};

const pl_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd`)
};

const pt_br2_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const pt_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral`)
};

const ro_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentare generală`)
};

const fi_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleiskatsaus`)
};

const sv_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Översikt`)
};

const vi_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng quan`)
};

const tr_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genel Bakış`)
};

const cs_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přehled`)
};

const bg_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общ преглед`)
};

const ru_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const uk_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Огляд`)
};

const ar_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظرة عامة`)
};

const hi_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवलोकन`)
};

const th_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาพรวม`)
};

const ja_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

const zh_cn2_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const zh_hant1_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const ko_components_sandboxshell_overview1 = /** @type {(inputs: Components_Sandboxshell_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Components_Sandboxshell_Overview1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_overview1 = /** @type {((inputs?: Components_Sandboxshell_Overview1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Overview1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_overview1(inputs)
	if (locale === "ms") return ms_components_sandboxshell_overview1(inputs)
	if (locale === "da") return da_components_sandboxshell_overview1(inputs)
	if (locale === "de") return de_components_sandboxshell_overview1(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_overview1(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_overview1(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_overview1(inputs)
	if (locale === "fil") return fil_components_sandboxshell_overview1(inputs)
	if (locale === "fr") return fr_components_sandboxshell_overview1(inputs)
	if (locale === "it") return it_components_sandboxshell_overview1(inputs)
	if (locale === "hu") return hu_components_sandboxshell_overview1(inputs)
	if (locale === "nl") return nl_components_sandboxshell_overview1(inputs)
	if (locale === "no") return no_components_sandboxshell_overview1(inputs)
	if (locale === "pl") return pl_components_sandboxshell_overview1(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_overview1(inputs)
	if (locale === "pt") return pt_components_sandboxshell_overview1(inputs)
	if (locale === "ro") return ro_components_sandboxshell_overview1(inputs)
	if (locale === "fi") return fi_components_sandboxshell_overview1(inputs)
	if (locale === "sv") return sv_components_sandboxshell_overview1(inputs)
	if (locale === "vi") return vi_components_sandboxshell_overview1(inputs)
	if (locale === "tr") return tr_components_sandboxshell_overview1(inputs)
	if (locale === "cs") return cs_components_sandboxshell_overview1(inputs)
	if (locale === "bg") return bg_components_sandboxshell_overview1(inputs)
	if (locale === "ru") return ru_components_sandboxshell_overview1(inputs)
	if (locale === "uk") return uk_components_sandboxshell_overview1(inputs)
	if (locale === "ar") return ar_components_sandboxshell_overview1(inputs)
	if (locale === "hi") return hi_components_sandboxshell_overview1(inputs)
	if (locale === "th") return th_components_sandboxshell_overview1(inputs)
	if (locale === "ja") return ja_components_sandboxshell_overview1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_overview1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_overview1(inputs)
	return ko_components_sandboxshell_overview1(inputs)
});
export { components_sandboxshell_overview1 as "components.sandboxShell.overview" }